// extracted by mini-css-extract-plugin
export default {"mobile":"_6ltnJ","root":"J7ewK","onImage":"o1k4O"};